export default "__VITE_ASSET__BG$13mVF__";